import { PartnerRequestModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class PartnerItemLoad {
  public static readonly type = '[PartnerItem] Load';

  constructor(public payload: string) {}
}

export class PartnerItemApprove {
  public static readonly type = '[PartnerItem] Approve';

  constructor(public payload: string) {}
}

export class PartnerItemCreate {
  public static readonly type = '[PartnerItem] Create';

  constructor(public payload: PartnerRequestModel) {}
}

export class PartnerItemUpdate {
  public static readonly type = '[PartnerItem] Update';

  constructor(public payload: PartnerRequestModel) {}
}

export class PartnerItemDelete {
  public static readonly type = '[PartnerItem] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; partnerIds: number[] }) {}
}

export class PartnerItemInitialState {
  public static readonly type = '[PartnerItem] Set initial state';
}

export class CarrierShortNamesLoad {
  public static readonly type = '[PartnerItem] Load Carrier Short Name';
}
